// Foto-Modus: pure Parametrik der prozeduralen Holzmaserung.
// Kein Three.js, kein Canvas — der Renderer zeichnet die hier berechneten
// Streifen-Definitionen. Deterministisch über einen seeded PRNG aus dem
// Farbwert: gleiche Materialfarbe → identische Maserung (cachebar, testbar).

export const STRIPE_MIN = 15
export const STRIPE_MAX = 25

// "#c99459", "c99459" oder Zahl → 24-Bit-Farbwert als Seed
export function colorSeed(color) {
  if (typeof color === "number") return color >>> 0
  const hex = String(color).replace(/^#/, "")
  const parsed = parseInt(hex, 16)
  return Number.isFinite(parsed) ? parsed >>> 0 : 0
}

// mulberry32: kleiner, deterministischer PRNG (liefert [0, 1))
export function mulberry32(seed) {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

// Streifen-Definitionen der Maserung. Alle Werte relativ (0..1 bzw. Anteile
// der Kantenlänge), damit der Renderer sie auf jede Canvas-Größe abbilden
// kann. Ohne count wählt der Seed selbst 15–25 Streifen.
//   y        Mittellinie quer zur Faser (0..1)
//   width    Streifenbreite als Anteil der Kantenlänge
//   alpha    Deckkraft der dunkleren Lasur (halbtransparent)
//   waveAmp  Amplitude der leichten Wellung (Anteil der Kantenlänge)
//   wavePhase/waveFreq  Phase (0..2π) und ganzzahlige Wellenzahl entlang der
//                       Faser — ganzzahlig, damit die Textur nahtlos kachelt
export function woodStripes(seedColor, count = null) {
  const rand = mulberry32(colorSeed(seedColor))
  const n = count == null
    ? STRIPE_MIN + Math.floor(rand() * (STRIPE_MAX - STRIPE_MIN + 1))
    : Math.max(1, Math.floor(count))
  return Array.from({ length: n }, () => ({
    y: rand(),
    width: 0.008 + rand() * 0.045,
    alpha: 0.05 + rand() * 0.13,
    waveAmp: 0.004 + rand() * 0.012,
    wavePhase: rand() * Math.PI * 2,
    waveFreq: 1 + Math.floor(rand() * 3)
  }))
}

// Feines Rauschen (Poren): deterministische Punktwolke aus demselben Seed,
// per Offset getrennt von der Streifen-Sequenz
export function woodNoise(seedColor, count = 350) {
  const rand = mulberry32(colorSeed(seedColor) ^ 0x9e3779b9)
  return Array.from({ length: count }, () => ({
    x: rand(),
    y: rand(),
    alpha: 0.02 + rand() * 0.06,
    dark: rand() < 0.7 // überwiegend dunkle, vereinzelt helle Poren
  }))
}
